/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import SubmissionQueryResult from './SubmissionQueryResult';

/**
 * The SubmissionOutputSubmissions model module.
 * @module model/SubmissionOutputSubmissions
 * @version 1.0
 */
class SubmissionOutputSubmissions {
    /**
     * Constructs a new <code>SubmissionOutputSubmissions</code>.
     * @alias module:model/SubmissionOutputSubmissions
     */
    constructor() { 
        
        SubmissionOutputSubmissions.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SubmissionOutputSubmissions</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SubmissionOutputSubmissions} obj Optional instance to populate.
     * @return {module:model/SubmissionOutputSubmissions} The populated <code>SubmissionOutputSubmissions</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SubmissionOutputSubmissions();

            if (data.hasOwnProperty('submissions')) {
                obj['submissions'] = ApiClient.convertToType(data['submissions'], [SubmissionQueryResult]);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/SubmissionQueryResult>} submissions
 */
SubmissionOutputSubmissions.prototype['submissions'] = undefined;






export default SubmissionOutputSubmissions;

